import { useEffect, useState } from 'react';

import { SearchIcon } from '../../../shared/ui/icons';
import { Input } from '../../../shared/ui/input';

const SEARCH_DELAY_MS = 250;

// Typed text stays local; the URL (and the query) follows once typing pauses.
export const ClientSearch = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (next: string) => void;
}) => {
  const [typed, setTyped] = useState(value);

  useEffect(() => setTyped(value), [value]);
  useEffect(() => {
    if (typed === value) return;
    const timer = setTimeout(() => onChange(typed), SEARCH_DELAY_MS);
    return () => clearTimeout(timer);
  }, [typed, value, onChange]);

  return (
    <Input
      size="sm"
      aria-label="Find a client by name or reference"
      placeholder="Name or reference"
      className="w-col-schedule"
      leading={<SearchIcon size={14} className="text-faint" />}
      value={typed}
      onChange={(event) => setTyped(event.target.value)}
    />
  );
};
